import { Form } from 'react-bootstrap';

function RenderProfesores(props) {   
    var listaprofesores = [];
    if(props.selectcursos[props.matcurso]){
        props.selectcursos[props.matcurso].nrcs.forEach((nrc)=>{						
            if(!listaprofesores.includes(props.selectcursos[props.matcurso][nrc]['PROFESOR'])){
                listaprofesores.push(props.selectcursos[props.matcurso][nrc]['PROFESOR']);
            }
        })
    }
    //console.log('LISTA DE PROFESORES');
    //console.log(listaprofesores);
    return(
        <ul className="listaprofesores">
        {listaprofesores.sort().map((profesor, key)=>
            <li key={props.tiempoconsulta+profesor}>
                <Form.Group controlId={props.matcurso+"_"+profesor}>
                    <Form.Check 
                        value={profesor}
                        type="switch" 
                        label={profesor.toUpperCase()}
                        name="checkboxprofesores[]"
                        onChange={props.onchangefiltroprofesor}
                    />
                </Form.Group>
            </li>
        )}
        </ul>
    )
}

export default RenderProfesores;